import Vue from "vue";

function initialState() {
  return {};
}

const state = initialState();

const actions = {
  getAssingmentEscalationDealerSettings: async function(context, request) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "get",
      "/schedule/assignmentescalationdealersetting/" +
        request 
    ).catch(err => err.response);
    return response && response.data && response.data.successful
      ? response.data.data
      : null;
  },

  saveAssingmentEscalationDealerSettings: async function(context, payload) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "/schedule/assignmentescalationdealersetting/save",
      payload
    ).catch(err => err.response);
    return response && response.data && response.data.successful
      ? response.data.successful
      : null;
  }
};

const mutations = {};

const getters = {};

export default {
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/AssignmentEscalationDealerSettings.js